import { BookingActivity } from '../models/booking/ActivitiesResponse';

export const formatLocation = (value: string): string =>
  value.replace(/([A-Z])/g, ' $1').trim();

export const formatUsTime = (slot: string): string => {
  const [hours, minutes] = slot.split(':').slice(0, 2).map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);

  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(date);
};

export const getSelectedActivityDurationHours = (
  activities: BookingActivity[],
  activityId: number | null
): number => {
  if (!activityId) {
    return 0;
  }

  const selected = activities.find((activity) => activity.id === activityId);
  return selected?.durationInHours ?? 0;
};

export const calculateRequiredCredits = (
  activities: BookingActivity[],
  activityId: number | null,
  fullMotion: number,
  esports: number
): number => {
  const durationHours = getSelectedActivityDurationHours(activities, activityId);
  return (durationHours ?? 0) * (fullMotion + esports) * 2;
};
